import { useCallback, useEffect, useRef, useState } from 'react';

// Matches RESET_LABEL_TIMER in useShareChannelButton, so the live region empties at the same moment
// the button's label flips back from "Copied!" — a second copy then re-announces, because the region's
// content changes rather than staying identical.
const ANNOUNCEMENT_TIMER = 3000;

type UseCopyLinkAnnouncementResult = {
	/** Whether the confirmation should currently be present in the live region. */
	isAnnouncing: boolean;
	announce: () => void;
};

export function useCopyLinkAnnouncement(): UseCopyLinkAnnouncementResult {
	const [isAnnouncing, setIsAnnouncing] = useState(false);
	const timeoutRef = useRef<number>(undefined);

	useEffect(() => () => window.clearTimeout(timeoutRef.current), []);

	const announce = useCallback(() => {
		window.clearTimeout(timeoutRef.current);
		setIsAnnouncing(true);
		timeoutRef.current = window.setTimeout(() => setIsAnnouncing(false), ANNOUNCEMENT_TIMER);
	}, []);

	return { isAnnouncing, announce };
}
